import { map } from "lodash";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getExistedSet(requirements: any) {
  const ids = map(requirements, "_id");
  return new Set(ids);
}

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getRemovedSet(requirements: any) {
  const removed = requirements.filter((rec) => rec.archived);
  const ids = map(removed, "_id");
  return new Set(ids);
}

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getUpdatedSet(requirements: any, existedSet?: any, removedSet?: any) {
  const isUpdated = (id) => existedSet?.has(id) && !removedSet?.has(id);
  const filtered = requirements.filter((rec) => isUpdated(rec.id));
  return new Set(map(filtered, "_id"));
}
